import * as yup from "yup";

const validation = (messages) => {
  return yup.object().shape({
    telecoms: yup.object().shape({}),
  });
};

export default validation;
